import { Location } from '../types';

export const ACTIVE_LOCATION_COLOR = '#171717';
export const INACTIVE_LOCATION_COLOR = '#dc2626';

export function isLocationActive(location: { isActive?: boolean | null } | null | undefined): boolean {
  return location?.isActive === true || location?.isActive === null || location?.isActive === undefined;
}

export function getLocationDisplayName(location: { name: string; isActive?: boolean | null }): string {
  return isLocationActive(location) ? location.name : `${location.name} (Inactive)`;
}

export function getDefaultLocationOptionStyle(): { color: string } {
  return { color: ACTIVE_LOCATION_COLOR };
}

export function getLocationOptionStyle(location: { isActive?: boolean | null }): { color: string } {
  return {
    color: isLocationActive(location) ? ACTIVE_LOCATION_COLOR : INACTIVE_LOCATION_COLOR,
  };
}
